import { Component, inject, output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { RaButtonComponent, RaModalComponent } from 'ra-ui';

/**
 * Apresentação da novidade dos apps de IA (MCP), aberta sozinha na primeira
 * entrada de quem ainda não conectou nenhum app.
 *
 * Mesmo desenho do modal do WhatsApp (foto à esquerda, explicação em três
 * passos à direita): a faixa no topo da home passava despercebida, e o modal é
 * o padrão que a casa já usa para contar uma novidade. Fechar marca como visto
 * para sempre; "Ver como conectar" leva para Integrações, onde está o passo a
 * passo de cada app.
 */
@Component({
    selector: 'mcp-intro',
    templateUrl: 'mcp-intro.component.html',
    styleUrl: 'mcp-intro.component.scss',
    imports: [TranslatePipe, RaModalComponent, RaButtonComponent],
})
export class McpIntroComponent {
    public onClose = output<void>();

    private _router = inject(Router);

    public open(): void {
        this.onClose.emit();
        this._router.navigate(['/platform/settings/integrations']);
    }
}
